import { css, jsx } from '@emotion/react';
import { Icon, Spacer, Tag, Colors } from '@zapier/design-system';
import { Menu, MenuItem, MenuTrigger, Popover } from 'react-aria-components';
import MoreButton from './MoreButton';
import { isLinkSelected } from './utils';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
import { baseReset, boxSizing, interactiveReset, } from '../../../../utils/style-mixins/reset';
const MENU_WIDTH = '280px';
const PopoverStyles = css(Object.assign(Object.assign({}, boxSizing), { borderRadius: 'var(--zds-radius-small)', background: 'var(--zds-background-weaker, #FFFDF9)', boxShadow: 'var(--zds-shadow-3)' }));
const MenuStyles = css(Object.assign(Object.assign({}, boxSizing), { display: 'flex', flexDirection: 'column', maxHeight: 'inherit', boxSizing: 'border-box', overflow: 'auto', padding: 'var(--zds-space-8, 8px)', width: MENU_WIDTH, outline: 'none' }));
const MenuItemStyles = css(Object.assign(Object.assign({}, interactiveReset), { display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--zds-space-12, 12px)', padding: 'var(--zds-space-8, 8px)', borderRadius: 'var(--zds-radius-small)', cursor: 'pointer', position: 'relative', alignItems: 'center', '&::before': {
        content: '""',
        position: 'absolute',
        pointerEvents: 'none',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        border: '2px solid transparent',
        borderRadius: 'var(--zds-radius-small)',
        zIndex: 2,
    }, '&[data-active="true"]': {
        backgroundColor: 'var(--zds-ui-brand-weakest, #FDF5F2)',
    }, '&[data-focus-visible]:not([data-active="true"]), &[data-hovered]:not([data-active="true"])': {
        backgroundColor: 'var(--zds-background-strong, #F5F3EB)',
    }, '&[data-focus-visible]': {
        '&::before': {
            border: 'var(--zds-border-focus, 2px solid #695BE8)',
            top: '-2px',
            right: '-2px',
            bottom: '-2px',
            left: '-2px',
        },
    } }));
const IconWrapperStyles = (isSelected) => css(Object.assign(Object.assign({}, boxSizing), { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--zds-space-8, 8px)', borderRadius: 'var(--zds-radius-small)', backgroundColor: isSelected
        ? 'var(--zds-ui-brand-weakest, #FDF5F2)'
        : 'var(--zds-background-strong, #F5F3EB)', '& svg': {
        fill: isSelected
            ? Colors.BrandOrange
            : 'var(--zds-text-default, #413735)',
    } }));
const RightColumnStyles = (isSelected) => css(Object.assign(Object.assign({}, boxSizing), { display: 'flex', flexDirection: 'column', font: isSelected ? `var(--zds-body-3)` : `var(--zds-body-1)`, color: 'var(--zds-text-default, #413735)' }));
const TitleRowStyles = css(Object.assign(Object.assign({}, baseReset), { display: 'flex', alignItems: 'center', position: 'relative' }));
const AfterIconPositionStyles = css(Object.assign(Object.assign({}, boxSizing), { position: 'absolute', right: 0, '& svg': {
        fill: 'var(--zds-text-weakest, #6f6765)',
    } }));
const DescriptionWrapperStyles = css(Object.assign(Object.assign({}, baseReset), { font: `var(--zds-minimal-print-1)`, color: 'var(--zds-text-weaker, #574E4C)' }));
const MoreItem = ({ description, href, icon, iconFilled, isSelected = false, tag, target, text, }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (jsx(MenuItem, { css: MenuItemStyles, "data-active": isSelected, href: getFullyQualifiedURL(href), key: text, id: text, onAction: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                option_selected: `UniversalSidebar MoreOption: ${text}`,
            });
        }, target: target, "data-zds": true },
        jsx("div", { "data-zds": true, css: IconWrapperStyles(isSelected) },
            jsx(Icon, { name: isSelected ? iconFilled : icon, size: 20, shouldAnimateFill: false })),
        jsx("div", { css: RightColumnStyles(isSelected), "data-zds": true },
            jsx("div", { css: TitleRowStyles, "data-zds": true },
                jsx("span", { "data-zds": true }, text),
                tag && (jsx("span", { style: { display: 'flex' } },
                    jsx(Spacer, { width: 8 }),
                    jsx(Tag, { size: "small", variant: "simple" }, tag))),
                target === '_blank' && (jsx("span", { "data-zds": true, css: AfterIconPositionStyles },
                    jsx(Icon, { name: "arrowOffsite", size: 16 })))),
            jsx("span", { "data-zds": true, css: DescriptionWrapperStyles }, description))));
};
export const MoreLinksMenu = ({ items, selectedHref }) => {
    const { isMoreLinksMenuOpen, setIsMoreLinksMenuOpen } = useUniversalNavContext();
    return (jsx(MenuTrigger, { isOpen: isMoreLinksMenuOpen, onOpenChange: setIsMoreLinksMenuOpen },
        jsx(MoreButton, { icon: items.icon, onClick: () => {
                emitUserInteractionEvent({
                    event_action: 'click',
                    option_selected: 'UniversalSidebar MoreLinksMenu click',
                });
            }, text: items.text }),
        jsx(Popover, { css: PopoverStyles },
            jsx(Menu, { css: MenuStyles }, items.moreLinksItems.map((item) => (jsx(MoreItem, Object.assign({}, item, { key: item.text, isSelected: isLinkSelected(item.href, selectedHref) }))))))));
};
//# sourceMappingURL=MoreLinksMenu.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
